import { numeric, required } from 'vuelidate/lib/validators'

const defaultEl = {
  id: null,
  name: {},
  code: '',
  order: '',
  group: null,
  allowManufacture: true,
  allowImport: true
};

export default {
  name: 'ProductServiceCategoryCategoryEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      code: { required },
      order: { required, numeric },
      group: { required }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.product_service_category.category.edit');
      }
      return this.$t('menu.config.product_service_category.category.new');
    },
    productServiceGroupOptions () {
      return this.$store.getters.getConfigOptions('product_service_category_groups', this.$i18n.locale);
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.allowImport = (parseInt(this.editEl.allowImport) === 1);
        this.editEl.allowManufacture = (parseInt(this.editEl.allowManufacture) === 1);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.editEl.group = this.$store.getters.getParamFromConfig('product_service_category_groups', this.editEl.group_id, 'code');
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        const self = this;
        this.ApiRequest.request('product-service-categories/edit/category', this.ApiRequest.REQUEST_POST, { category: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self, { 'category.code': 'general.item.code' });
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
